<empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
<div class="cont">
  <div class="fondo-mundo">
    <div class="cont-mundo">
      <div class="texto-mundo">
        <span class="texto-mundo-principal">Bienvenido a ENVANET, la plataforma informática de ENVALORA,</span> un entorno personal y privado para realizar
        diferentes gestiones con ENVALORA.
        <br>
        <br> <span *ngIf="!canViewBannerDAE() && !canViewBannerCVF()" class="texto-mundo-pequenio"> Para comenzar, selecciona una opción en el menú superior. </span>
      </div>
    </div>
    <div class="imagen-superpuesta" *ngIf="canViewBannerDAE()">
      <div class="contenedor-texto">
        <div class="texto-principal-centrado" [innerHTML]="campana?.textoInicio 
                ? campana?.textoInicio 
                : mensajePorDefectoDAE">
        </div>
        <div class="texto-fecha-centrado-dae">
          Fecha límite: {{fechaCampana}}
        </div>
      </div>
      <button class="boton-centrado-dae" (click)="abrirDeclaracion()">
        Entrar a la declaración
      </button>
    </div>
    <div class="imagen-superpuesta" *ngIf="canViewBannerCVF()">
      <div class="contenedor-texto">
        <div class="texto-principal-centrado"  [innerHTML]="campana?.textoInicio 
                ? campana?.textoInicio 
                : mensajePorDefectoCVF">
          <!-- Ha comenzado la <strong>campaña</strong> <br> de <strong>Certificado</strong> <br> de <strong>Valorización Final</strong> -->
        </div>
        <div class="texto-fecha-centrado-cvf">
          Fecha límite: {{fechaCampana}}
        </div>
      </div>
      <button class="boton-centrado-cvf" (click)="abrirCvf()">
        Entrar al Certificado de Valorización Final
      </button>
    </div>
  </div>
  <div class="fondo-gris">
      <div class="texto-instrucciones">
        En la esquina superior derecha  tiene a su disposición el buzón de comunicaciones con Envalora para todas las consultas relacionadas con la plataforma y/o las declaraciones de envases. Cualquier otra consulta puede dirigirla a <a [href]="'mailto:' + 'contacto@envalora.es'">contacto@envalora.es</a>
      </div>
    <div class="tarjeta">
      <h4 class="titulo-tarjeta">Documentación de interés</h4>
      <mat-accordion class="example-headers-align">

        <mat-expansion-panel *ngIf="documentosAdheridos.length > 0" [expanded]="step === 0" (opened)="setStep(0)" hideToggle #panelAdheridos>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Adheridos
            </mat-panel-title>
            <mat-panel-description>
              <mat-icon>{{ panelAdheridos.expanded ? 'remove' : 'add' }}</mat-icon>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="contenido-tarjeta">
            <div class="documento" *ngFor="let documento of documentosAdheridos">
              <div class="filas-documentos">
                <mat-icon>insert_drive_file</mat-icon>
                <div>{{documento?.nombre}}</div>
              </div>
              <div (click)="descargarDocumento(documento)">
                <mat-icon class="descargar-archivo">download</mat-icon>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel *ngIf="documentosDeclaracion.length > 0" [expanded]="step === 1" (opened)="setStep(1)" hideToggle #panelDeclaracion>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Declaración envases
            </mat-panel-title>
            <mat-panel-description>
              <mat-icon>{{ panelDeclaracion.expanded ? 'remove' : 'add' }}</mat-icon>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="contenido-tarjeta">
            <div class="documento" *ngFor="let documento of documentosDeclaracion">
              <div class="filas-documentos">
                <mat-icon>insert_drive_file</mat-icon>
                <div>{{documento?.nombre}}</div>
              </div>
              <div (click)="descargarDocumento(documento)">
                <mat-icon class="descargar-archivo">download</mat-icon>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel *ngIf="documentosPoseedoresFinales.length > 0" [expanded]="step === 2" (opened)="setStep(2)" hideToggle #panelPoseedoresFinales>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Poseedores Finales
            </mat-panel-title>
            <mat-panel-description>
              <mat-icon>{{ panelPoseedoresFinales.expanded ? 'remove' : 'add' }}</mat-icon>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="contenido-tarjeta">
            <div class="documento" *ngFor="let documento of documentosPoseedoresFinales">
              <div class="filas-documentos">
                <mat-icon>insert_drive_file</mat-icon>
                <div>{{documento?.nombre}}</div>
              </div>
              <div (click)="descargarDocumento(documento)">
                <mat-icon class="descargar-archivo">download</mat-icon>
              </div>
            </div>
          </div>

        </mat-expansion-panel>
        <mat-expansion-panel *ngIf="documentosPuntoRecogida.length > 0" [expanded]="step === 3" (opened)="setStep(3)" hideToggle #panelPuntoRecogida>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Puntos de recogida
            </mat-panel-title>
            <mat-panel-description>
              <mat-icon>{{ panelPuntoRecogida.expanded ? 'remove' : 'add' }}</mat-icon>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="contenido-tarjeta">
            <div class="documento" *ngFor="let documento of documentosPuntoRecogida">
              <div class="filas-documentos">
                <mat-icon>insert_drive_file</mat-icon>
                <div>{{documento?.nombre}}</div>
              </div>
              <div (click)="descargarDocumento(documento)">
                <mat-icon class="descargar-archivo">download</mat-icon>
              </div>
            </div>
          </div>

        </mat-expansion-panel>
        <mat-expansion-panel *ngIf="documentosSDDRAbierto.length > 0" [expanded]="step === 4" (opened)="setStep(4)" hideToggle #panelSDDRAbierto>
          <mat-expansion-panel-header>
            <mat-panel-title>
              SDDR Abierto y Cerrado
            </mat-panel-title>
            <mat-panel-description>
              <mat-icon>{{ panelSDDRAbierto.expanded ? 'remove' : 'add' }}</mat-icon>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="contenido-tarjeta">
            <div class="documento" *ngFor="let documento of documentosSDDRAbierto">
              <div class="filas-documentos">
                <mat-icon>insert_drive_file</mat-icon>
                <div>{{documento?.nombre}}</div>
              </div>
              <div (click)="descargarDocumento(documento)">
                <mat-icon class="descargar-archivo">download</mat-icon>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
        <!--<mat-expansion-panel *ngIf="documentosSDDRCerrado.length > 0" [expanded]="step === 5" (opened)="setStep(5)" hideToggle #panelSDDRCerrado>
          <mat-expansion-panel-header>
            <mat-panel-title>
              SDDR Cerrado
            </mat-panel-title>
            <mat-panel-description>
              <mat-icon>{{ panelSDDRCerrado.expanded ? 'remove' : 'add' }}</mat-icon>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="contenido-tarjeta">
            <div class="documento" *ngFor="let documento of documentosSDDRCerrado">
              <div class="filas-documentos">
                <mat-icon>insert_drive_file</mat-icon>
                <div>{{documento?.nombre}}</div>
              </div>
              <div (click)="descargarDocumento(documento)">
                <mat-icon class="descargar-archivo">download</mat-icon>
              </div>
            </div>
          </div>
        </mat-expansion-panel>-->
        <mat-expansion-panel *ngIf="documentosAcuerdosGestores.length > 0" [expanded]="step === 6" (opened)="setStep(6)" hideToggle #panelAcuerdoGestores>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Acuerdos con gestores
                </mat-panel-title>
                <mat-panel-description>
                  <mat-icon>{{ panelAcuerdoGestores.expanded ? 'remove' : 'add' }}</mat-icon>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div class="contenido-tarjeta">
                <div class="documento" *ngFor="let documento of documentosAcuerdosGestores">
                  <div class="filas-documentos">
                    <mat-icon>insert_drive_file</mat-icon>
                    <div>{{documento?.nombre}}</div>
                  </div>
                  <div (click)="descargarDocumento(documento)">
                    <mat-icon class="descargar-archivo">download</mat-icon>
                  </div>
                </div>
              </div>
        </mat-expansion-panel>
      </mat-accordion>

      <!-- <mat-card class="doc-tarjeta">
        <mat-card-content>
          <mat-card-title class="cabecera-tarjeta">Documentación de interés ({{documentos?.length}})</mat-card-title>
          <div class="contenido-tarjeta">
            <div class="documento" *ngFor="let documento of documentos">
              <div class="filas-documentos">
                <mat-icon style="color:#6b4e4e">description</mat-icon>
                <div>{{documento?.nombre}}</div>
              </div>
              <div (click)="descargarDocumento(documento)">
                <mat-icon class="descargar-archivo">
                  download</mat-icon>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card> -->
    </div>
    <div class="tarjeta-ecoembes ecoembes" *ngIf="this.esEcoembes">
      <mat-card>
        <mat-card-content>
          <div class="container-ecoembes">
            <div>Si necesitas declarar envases de otros tipos te ofrecemos este acceso directo a Ecoembes.</div>
            <div class="imagen-ecoembes" (click)="abrirEnlace('https://plataformaenvases.ecoembes.com/home')"></div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="">
      <div class="fondo-rrss">
        <div class="cont-rss">
          <div class="texto-rrss">
            Puede seguirnos en nuestras redes sociales para estar al día de todas las actividades de nuestro sistema.
          </div>
          <div class="imagen"></div>
          <div class="iconos-rrss">
            <div class="imagen imagen-x" (click)="abrirEnlace('https://x.com/Envalora_es?s=20')"></div>
            <div class="imagen imagen-in" (click)="abrirEnlace('https://es.linkedin.com/company/envalora')"></div>
            <div class="imagen imagen-youtube" (click)="abrirEnlace('https://www.youtube.com/@envalora3972')"></div>
          </div>
          <div class="texto-rrss">
            Y en nuestra web <span (click)="abrirEnlace('https://envalora.es/')" class="enlace">www.envalora.es</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>